export default class AuthApi {
  token(): string {
    const access_token = sessionStorage.getItem("access_token");
    if (!access_token) {
      return "";
    }
    return access_token;
  }

  createHeaders(contentType?: boolean) {
    const _headers = new Headers();
    if (contentType) {
      _headers.append("Content-Type", "application/json");
    }
    _headers.append("Accept", "application/json,*/*");
    _headers.append("Authorization", `Bearer ${this.token()}`);
    return _headers;
  }

  properties(method: string, contentType?: boolean): RequestInit {
    return {
      method: method,
      mode: "cors" as RequestMode,
      headers: this.createHeaders(contentType),
    };
  }
}
